var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{class:_vm.eventList[_vm.event].icon}),_vm._v(" "+_vm._s(_vm.eventList[_vm.event].description)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }